import React from 'react'
import { AuthProvider } from '@dexter-experts/auth-react'
import '@dexter-experts/auth-react/styles.css'
import Routes from './Routes'
import { MessageProvider } from './contexts/MessageContext'
import { getRegisterMetadata } from './lib/referralPartner'
import 'semantic-ui-css/semantic.min.css'
import './styles/styles.scss'

const authApiUrl = (process.env.REACT_APP_GRAPHQL_BASE_URL || '').replace(
  /\/graphql\/?$/,
  ''
)

const logoutRedirectTo = localStorage.getItem('publicProject')
  ? `${window.location.origin}/landing/authenticate?state=login`
  : window.location.origin

const App = () => (
  <AuthProvider
    apiUrl={authApiUrl}
    loginRedirectTo="/dashboard"
    logoutRedirectTo={logoutRedirectTo}
    getRegisterMetadata={getRegisterMetadata}
  >
    <MessageProvider>
      <Routes />
    </MessageProvider>
  </AuthProvider>
)

export default App
